module.exports = __webpack_public_path__ + "img/UAV_auto1.7d8a9b15.png";